/**
 * An extension of the autoplayManager class
 *
 * Allows for game specific autoplay themes, button colours etc.
 */
(function () {
  autoplayManager.updateOKButton = function () {
    var canEnable =
      (autoplayManager.stake <= gdk.getBalance() ||
        gdk.allowSpinIfNotEnoughCredit()) &&
      autoplayManager.lossLimitSet;

    autoplayManager.dialog.OKButton.enableButton(canEnable);

    // only turn ok button green when it's enabled
    autoplayManager.dialog.OKButton.alpha = canEnable ? 1 : 0.5;
    autoplayManager.dialog.OKButtonText.style.fill = canEnable
      ? 0x62e702
      : 0xffffff;
  };

  autoplayManager.onOrientationChange = function () {
    if (autoplayManager.dialog.container.visible) {
      var background = resourceManager.get("autoplayContainer:autoplayBacker");
      background.interactive = true;
      background.visible = true;
      autoplayManager.dialog.numberOFSpinsButtons.forEach((button) => {
        button.buttonText.position.set(-2, -5);
      });
    }
  };

  autoplayManager.openDialog = function (
    confirmCallback,
    cancelCallback,
    coinSize,
    numberOfWinlines
  ) {
    // allow background touch to close dialog
    var background = resourceManager.get("autoplayContainer:autoplayBacker");
    background.interactive = true;
    background.visible = true;
    background.mousedown = background.touchstart = autoplayManager.onCancel;

    let self = this;
    Reflex.registerEventHandler("orientationChange", function () {
      self.onOrientationChange();
    });

    // Coins is the cost of playing one winline
    if (coinSize !== undefined) {
      autoplayManager.stake = coinSize * numberOfWinlines;
    }

    var numberOfSpins = autoplayManager.AP.fields.numberOfRounds.values;

    if (!autoplayManager.dialog.numberOFSpinsButtons) {
      autoplayManager.dialog.numberOFSpinsButtons = [];

      var xLeft = -280;
      var xRight = 280;
      var yStart = -10;
      var columns = 5;

      var xGap = (-xLeft + xRight) / (columns - 1);
      var yGap = 60;

      var rowCount = 0;
      var colCount = 0;

      for (let i = 0; i < 10; i++) {
        let button = resourceManager.get(
          "autoplayContainer:autoplayBackground:numberOfSpinsButtonContainer:button" +
            i
        );

        if (rowCount === columns) {
          rowCount = 0;
          colCount++;
        }

        var xPos = xLeft + xGap * rowCount;
        var yPos = yStart + yGap * colCount;

        for (var name in resourceManager.configuration.layouts) {
          if (resourceManager.configuration.layouts[name].mapped) continue;
          button.Props[name].position.x = xPos;
          button.Props[name].position.y = yPos;
        }

        button.position.set(xPos, yPos);

        if (numberOfSpins[i]) {
          button.setButtonText(numberOfSpins[i]);
          button.buttonText.position.set(-2, -5);
          button.buttonText.style.fill = i == 0 ? 0x62e702 : 0xffffff;
          button.enableButton(true);
          button.spinValue = numberOfSpins[i];
          button.nosIndex = i;
          button.onPressedCallback = autoplayManager.onNOSselect;
          autoplayManager.dialog.numberOFSpinsButtons.push(button);
        } else {
          button.enableButton(false);
          button.buttonSprite.visible = false;
          button.setButtonText("");
        }

        rowCount++;
      }
    }

    autoplayManager.dialog.buttonGlow = resourceManager.get(
      "buttonContainer:buttonBar:autoplayButton:glow"
    );
    autoplayManager.dialog.buttonGlow.visible = true;

    autoplayManager.lossLimitSet = false;

    let data = autoplayManager.AP.fields["numberOfRounds"];
    autoplayManager.AP.setField("numberOfRounds", data.values[0]);
    data = autoplayManager.AP.fields["lossLimit"];
    autoplayManager.AP.setField("lossLimit", data.values[0]);
    data = autoplayManager.AP.fields["singleWinLimit"];
    autoplayManager.AP.setField("singleWinLimit", data.values[0]);

    autoplayManager.dialog.OKButtonText = resourceManager.get(
      "autoplayContainer:autoplayBackground:autoplayOK:label"
    );

    // default start button to look disabled
    autoplayManager.dialog.OKButton.alpha = 0.5;
    autoplayManager.dialog.OKButtonText.style.fill = 0xffffff;

    autoplayManager.dialog.OKButton.enableButton(false);

    // Fade in dialog
    autoplayManager.dialog.container.visible = true;
    autoplayManager.dialog.container.alpha = 0;
    timerManager.addTimer(
      300,
      autoplayManager.fadeInDialog,
      autoplayManager.fadeInDialogCompete
    );

    autoplayManager.dialog.OKButton.onPressedCallback = function () {};
    autoplayManager.dialog.cancelButton.onPressedCallback = function () {};

    // Store callbacks
    autoplayManager.callbacks.OK = confirmCallback;
    autoplayManager.callbacks.cancel = cancelCallback;

    // let data = autoplayManager.AP.fields["numberOfRounds"];
    autoplayManager.AP.setField(
      "numberOfRounds",
      data.values[autoplayManager.indexToUse]
    );

    autoplayManager.dialog.NOStext.text =
      autoplayManager.AP.fields["numberOfRounds"].currentValue;
    autoplayManager.dialog.LLtext.setTranslationPhrase("t_autoplayPleaseSet");
    autoplayManager.dialog.SWLtext.setTranslationPhrase(
      autoplayManager.getSWLtext()
    );

    let firstStakeButton = autoplayManager.dialog.numberOFSpinsButtons[0];
    firstStakeButton.onPressedCallback();
  };

  autoplayManager.onNOSselect = function () {
    soundManager.play("buttonPressed");

    for (
      var i = 0;
      i < autoplayManager.dialog.numberOFSpinsButtons.length;
      i++
    ) {
      autoplayManager.dialog.numberOFSpinsButtons[
        i
      ].buttonText.style.fill = 0xffffff;
    }
    this.buttonText.style.fill = 0x62e702;
    var data = autoplayManager.AP.fields["numberOfRounds"];

    autoplayManager.indexToUse = this.nosIndex;
    autoplayManager.AP.setField(
      "numberOfRounds",
      data.values[autoplayManager.indexToUse]
    );
    autoplayManager.dialog.NOStext.text =
      autoplayManager.AP.fields["numberOfRounds"].currentValue;
    autoplayManager.updateOKButton();
  };

  autoplayManager.fadeOutDialogCancelled = function () {
    var background = resourceManager.get("autoplayContainer:autoplayBacker");
    background.interactive = false;
    background.visible = false;

    autoplayManager.dialog.container.visible = false;
    autoplayManager.dialog.buttonGlow.visible = false;

    autoplayManager.dialog.container.alpha = 1;

    autoplayManager.callbacks.cancel();
  };

  autoplayManager.fadeOutDialogAccepted = function () {
    var background = resourceManager.get("autoplayContainer:autoplayBacker");
    background.interactive = false;
    background.visible = false;

    autoplayManager.dialog.container.visible = false;
    autoplayManager.dialog.container.alpha = 1;

    // Now we have left dialog, start autoplay
    autoplayManager.AP.start(autoplayManager.stake);
    autoplayManager.callbacks.OK();
  };

  autoplayManager.onModal = function (msg) {
    // is something takes us out of modal but we are still visible, keep modal
    // For example, history will cause Gati wrapper to pause our game and resume when history closed.
    // Resume will clear modal but this settings menu is still open allowing the player to spin behind the settings menu
    if (autoplayManager.dialog.container.visible && msg.reason === undefined) {
      messageBus.post("game:modal", { reason: "Autoplay open" });
    }
  };

  // Do the reset here so that subsequent entries into the dialog aren't reset.
  messageBus.subscribe("spinner:GameConfigEvent", function () {
    autoplayManager.AP.reset();
    autoplayManager.indexToUse = 0;
  });

  messageBus.subscribe("game:modal", autoplayManager.onModal);
})();
